import { OfficeGame } from './game.js';
import { GameUI } from './ui.js';

const game = new OfficeGame();
const ui = new GameUI(game);

// Main game loop
function gameLoop() {
    game.update();
    ui.update();
    requestAnimationFrame(gameLoop);
}

// Start the game loop
gameLoop();
